export const DEFAULT_VOLUME_LEVEL = 0.5;
